<div *ngFor="let tool of tools">
  <button 
    (click)='openModal(tool)' 
    class="btn btn-tools btn-tool-selector-default" 
    [style.backgroundImage]="'url('+ getIcon('glyph', tool.name) +')'"
  ></button>
</div>
